import React, { useState } from "react";
import PropTypes from "prop-types";
import { CloseButton } from "./CloseButton";
import infoIcon from "assets/IconInfoBox.svg?url";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const InfoBox = ({ canClose, children }) => {
	const [hide, setHide] = useState(false);

	const onClickCloseButton = () => {
		setHide(true);
	};

	if (hide) return null;

	return (
		<div className="InfoBox">
			<img src={infoIcon} className="InfoBox_icon" alt="" />
			<div> {children} </div>
			{canClose && <CloseButton className="InfoBox_closeButton" onClick={onClickCloseButton} />}
		</div>
	);
};

InfoBox.propTypes = {
	canClose: PropTypes.bool,
	children: PropTypes.node,
};
